import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { AccordionContainer, AccordionHeader } from "./styles";
import { IconChevronDown } from "../icons";
import { AnimatePresence, motion } from "framer-motion";
export var Accordion = forwardRef(function Accordion(_a, ref) {
    var header = _a.header, children = _a.children, props = __rest(_a, ["header", "children"]);
    var _b = useState(false), accordionOpen = _b[0], setAccordionOpen = _b[1];
    return (_jsxs(AccordionContainer, __assign({ ref: ref }, props, { children: [_jsxs(AccordionHeader, { onClick: function () { return setAccordionOpen(function (state) { return !state; }); }, children: [_jsx(IconChevronDown, { style: {
                            transform: accordionOpen && "rotateX(180deg)",
                            transition: "transform 0.3s",
                        } }), header] }), _jsx(AnimatePresence, { children: accordionOpen && (_jsx(motion.div, { style: { overflow: "hidden" }, initial: { height: 0 }, animate: { height: "auto" }, exit: { height: 0 }, transition: { duration: 0.3 }, children: children })) })] })));
});
//# sourceMappingURL=index.js.map